
import React from "react";
import { Avatar } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { BrainCircuit, User, Paperclip } from "lucide-react";
import { ChatMessage } from "./types";

interface MessageListProps {
  messages: ChatMessage[];
  isTyping: boolean;
}

const MessageList: React.FC<MessageListProps> = ({ messages, isTyping }) => {
  return (
    <div className="h-[350px] overflow-y-auto p-4 space-y-4">
      {messages.map((msg) => (
        <div key={msg.id} className="flex items-start gap-2">
          <Avatar className={`h-8 w-8 flex-shrink-0 ${msg.sender === "ai" ? "bg-primary" : "bg-gray-300"}`}>
            {msg.sender === "ai" ? (
              <BrainCircuit className="h-4 w-4 text-white" />
            ) : (
              <User className="h-4 w-4 text-gray-700" />
            )}
          </Avatar>
          
          <div className="flex-1">
            <div className="flex items-center gap-1">
              <span className="text-sm font-medium">
                {msg.sender === "ai" ? "VirtuStaff" : "You"}
              </span>
              <span className="text-xs text-muted-foreground">
                {msg.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
            
            <div className="mt-1 text-sm whitespace-pre-line">
              {msg.mentions && msg.mentions.length > 0 && (
                msg.mentions.map((mention, i) => (
                  <Badge key={i} variant="secondary" className="mr-1 font-normal">
                    {mention}
                  </Badge>
                ))
              )}
              {msg.content}
            </div>
            
            {msg.attachments && msg.attachments.length > 0 && (
              <div className="mt-2 inline-flex items-center gap-1 bg-muted px-2 py-1 rounded text-xs">
                <Paperclip className="h-3 w-3" />
                <span>{msg.attachments[0]}</span>
              </div>
            )}
          </div>
        </div>
      ))}
      
      {isTyping && (
        <div className="flex items-start gap-2">
          <Avatar className="h-8 w-8 flex-shrink-0 bg-primary">
            <BrainCircuit className="h-4 w-4 text-white" />
          </Avatar>
          <div className="flex-1">
            <div className="flex items-center gap-1">
              <span className="text-sm font-medium">VirtuStaff</span>
            </div>
            <div className="mt-1 text-sm text-muted-foreground">typing...</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageList;
